import { useEffect, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "../../../../hooks";
import { useControlContext } from "../../../control";
import { selectChatId, selectChatMessages } from "../../selectors";
import { getMessages } from "../../actions";
import { Context } from "./context";
import { getMessagesByDates } from "./helpers";
import type { ProviderProps } from "./types";

export const MessagesProvider = ({ children }: ProviderProps) => {
  const dispatch = useAppDispatch();
  const { api } = useControlContext();
  const { getMessagesApi } = api;
  const chatId = useAppSelector(selectChatId);
  const messageList = useAppSelector(selectChatMessages);

  const messages = useMemo(
    () => getMessagesByDates(messageList),
    [messageList]
  );

  useEffect(() => {
    if (chatId) {
      const params = { getMessagesApi, chatId };

      dispatch(getMessages(params));
    }
  }, [chatId]);

  return <Context.Provider value={{ messages }}>{children}</Context.Provider>;
};
